export const blockIconsSocialThumbDownNew = (
	<span className='material-symbols-outlined'>thumb_down</span>
);
